import styled from 'styled-components';

const QuestionMarkContainer = styled.div`
  border: 1px solid black;
  border-radius: 50%;
  padding: 2.5px;
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -7px;
  left: 2px;
  cursor: help;
`;

const IconQuestionMark = styled.img`
  width: 92%;
`;

const PopoverContent = styled.div`
  padding: 10px 15px;
  font-size: 13px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.text};
  white-space: pre-line;
`;

export const Styled = {
  QuestionMarkContainer,
  IconQuestionMark,
  PopoverContent,
};
